module.exports = __webpack_public_path__ + "img/sec16mob.880a82a0.png";